import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const OAAP_BASE = `${getNodeServerUrl()}/oaap`;

/**
 * Submit feedback (ZM on BM, or NSM on ZM).
 * @param {Object} payload - { submissionId, reviewerCode, reviewerName, reviewerRole, rating, remarks }
 * @returns {Promise}
 */
export const submitFeedbackApi = (payload) =>
  axios.post(`${OAAP_BASE}/feedback`, payload);

/**
 * Get all feedback entries for a submission.
 * @param {number} submissionId
 * @returns {Promise}
 */
export const getFeedbackApi = (submissionId) =>
  axios.get(`${OAAP_BASE}/feedback/${submissionId}`);
